import * as React from 'react';

export interface ITopMenuLinkProps {
  link: string;
  name: string;
  onClickLink(): void;
  title: string;
  menuHoverLineView: React.ReactElement;
}

export const TopMenuLink = (props: ITopMenuLinkProps) => {
  const { link, name, onClickLink, title, menuHoverLineView } = props;

  return (
    <a data-ref={name} href={link} onClick={onClickLink} className="c-header-link">
      {title}
      {menuHoverLineView}
    </a>
  );
};
